import PropTypes from "prop-types";
import { NotificationBell } from "./notificationBell";

export function Headers({ name, subtitle, additionalInfo, actions }) {
  return (
    <div className="mb-4 sm:mb-8">
      <div className="flex items-center justify-between">
        <h1 className="text-lg sm:text-2xl font-semibold text-gray-900">
          {name}
        </h1>
        <div className="flex items-center gap-2">
          {actions && (
            <div className="hidden xs:flex items-center gap-2">{actions}</div>
          )}
          <NotificationBell />
        </div>
      </div>
      {subtitle && (
        <p className="text-xs sm:text-sm text-gray-600 mt-1">{subtitle}</p>
      )}
      {additionalInfo && (
        <p className="text-xs sm:text-sm text-gray-600 mt-1">
          {additionalInfo}
        </p>
      )}
      {actions && (
        <div className="flex items-center gap-2 mt-3 xs:hidden">{actions}</div>
      )}
    </div>
  );
}

Headers.propTypes = {
  name: PropTypes.node,
  subtitle: PropTypes.node,
  additionalInfo: PropTypes.node,
  actions: PropTypes.node,
};
